import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "axios";
const getAppointment = (axios, appointmentReferenceId, isOpenAppointment) => async () => {
  const url = isOpenAppointment ? `/api/v1/internal/open-appointments/${appointmentReferenceId ?? ""}` : `/api/v1/internal/appointments/${appointmentReferenceId ?? ""}`;
  const { data } = await axios.get(url);
  return data ?? null;
};
const useAppointment = ({
  appointmentReferenceId,
  auth,
  baseURL,
  isOpenAppointment = false
}) => {
  const { echoCore } = useAxiosProvider();
  const queryKey = useMemo(() => ["appointment-details"], []);
  const enabled = !!appointmentReferenceId && !!auth && !!baseURL;
  const { data: appointment, ...queryResult } = useQuery({
    queryKey,
    queryFn: getAppointment(echoCore, appointmentReferenceId, isOpenAppointment),
    keepPreviousData: false,
    cacheTime: 0,
    staleTime: 0,
    enabled
  });
  const data = useMemo(() => appointmentReferenceId ? appointment : null, [appointment, appointmentReferenceId]);
  return {
    queryKey,
    queryResult,
    data
  };
};
export {
  useAppointment
};
